<template>
  <div class="flex flex-col">
    <button
      class="warning-button ml-auto mr-4"
      @click="updateSyncCargos()"
      v-if="!loading"
    >
      Sync Charges
    </button>
    <BaseSmallSpinner v-if="loading"></BaseSmallSpinner>
    <table class="default-table text-center my-6" v-else>
      <thead>
        <th>ID</th>
        <th>Charge ID</th>
        <th>Code</th>
        <th>Description</th>
      </thead>
      <tbody>
        <tr v-for="cargo in cargos" :key="cargo.id">
          <td>{{ cargo.id }}</td>
          <td>{{ cargo.cargoId }}</td>
          <td>{{ cargo.code }}</td>
          <td>{{ cargo.description }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { getCargos, getSyncCargos } from "@/api/Infoauto.js";
export default {
  name: "Cargos",
  data() {
    return {
      cargos: [],
      loading: true
    };
  },
  async mounted() {
    try {
      this.cargos = await getCargos();
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  },
  methods: {
    async updateSyncCargos() {
      this.loading = true;
      try {
        this.cargos = await getSyncCargos();
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    }
  }
};
</script>
